import { WeatherForecast } from '../domain/weather/WeatherForecast';
import { WeatherForecastDTO } from '../domain/weather/WeatherForecastDTO';

export class WeatherForecastMapper {
  static toDomain(dto: WeatherForecastDTO): WeatherForecast {
    const { date, weatherCode, maxTemp, minTemp } = dto;

    return WeatherForecast.create({
      date: new Date(date),
      weatherCode,
      maxTemp,
      minTemp,
    });
  }
}
